// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1PermissionSchema = z.object({
  resource: z.coerce.string().describe("Resource name (e.g., user, project, hour)"),
  permissions: z.array(z.coerce.string()).describe("List of permitted operations for this resource"),
  global_permissions: z.array(z.coerce.string()).describe("List of globally permitted operations for this resource"),
});
